var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.26851 13.3081H5.14736C5.00356 13.3081 4.86291 13.3502 4.74278 13.4293C4.62265 13.5083 4.52831 13.6208 4.47139 13.7529L1.36777 20.9796L8.73853 17.2151C7.8562 15.9942 6.98315 14.6476 6.26851 13.3081ZM20.5284 13.7529C20.4715 13.6208 20.3772 13.5083 20.2571 13.4293C20.137 13.3502 19.9964 13.3081 19.8526 13.3081H18.7315C17.3818 15.8372 15.4156 18.4509 14.1647 19.8888C13.2851 20.8978 11.7138 20.8966 10.8355 19.8888C10.7456 19.7856 10.2766 19.2426 9.63057 18.4076L8.30176 19.0866L13.3284 24.1035L22.8529 19.1657L20.5284 13.7529ZM0.460987 23.0917L0.0601083 24.0252C-0.14746 24.5084 0.208009 25.048 0.735841 25.048H11.5293C11.5968 24.9979 11.5976 25.0009 11.96 24.813L6.92598 19.7895L0.460987 23.0917ZM24.9399 24.0253L23.4339 20.5185L14.6967 25.048H24.2642C24.7908 25.048 25.1478 24.5094 24.9399 24.0253ZM13.2353 6.65562C13.2353 6.25088 12.9053 5.92188 12.5 5.92188C12.0945 5.92188 11.7647 6.25088 11.7647 6.65562C11.7647 7.06016 12.0945 7.3894 12.5 7.3894C12.9053 7.3894 13.2353 7.06016 13.2353 6.65562Z",
    fill: "#0C71C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.055 18.8778C13.3025 18.5936 19.1175 11.8672 19.1175 7.24338C19.1175 -2.29109 5.88281 -2.40745 5.88281 7.24338C5.88281 11.8672 11.6978 18.5936 11.9453 18.8778C12.2385 19.2141 12.7624 19.2137 13.055 18.8778ZM10.2943 6.65647C10.2943 5.4426 11.2838 4.4552 12.5001 4.4552C13.7163 4.4552 14.7058 5.44265 14.7058 6.65647C14.7058 7.87014 13.7163 8.85754 12.5001 8.85754C11.2838 8.85754 10.2943 7.87014 10.2943 6.65647Z",
    fill: "#0C71C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/Locations.689f5975ca43d6d6f9d46b02d9c60797.svg";
export { ForwardRef as ReactComponent };